"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var platform = require("platform");

var Metadata = /*#__PURE__*/function () {
  function Metadata() {
    _classCallCheck(this, Metadata);
  }

  _createClass(Metadata, null, [{
    key: "getMetadata",
    value: function getMetadata(options) {
      var platformInfo = typeof navigator !== 'undefined' ? platform.parse(navigator.userAgent) : platform;
      var overrides = options && options.clientMetadata ? options.clientMetadata : {};
      var fieldNames = ['ver', 'env', 'envv', 'os', 'osv', 'osa', 'type', 'sdk', 'sdkv', 'dev', 'devv', 'devt', 'app', 'appv'];
      var defaults = {
        'env': platform.name,
        'envv': platform.version,
        'os': platform.os.family,
        'osv': platform.os.version,
        'osa': platform.os.architecture,
        'sdk': 'js-default'
      };
      var finalClientMetadata = {};
      fieldNames.filter(function (key) {
        return key in overrides || key in defaults;
      }).forEach(function (key) {
        return finalClientMetadata[key] = key in overrides ? overrides[key] : defaults[key];
      });
      return finalClientMetadata;
    }
  }]);

  return Metadata;
}();

exports.Metadata = Metadata;